import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

export const readWorkflowAssignment: OpalApi<
  'ReadWorkflowAssignmentV3',
  200
> = async ({
  params,
}: Parameters<OpalApi<'ReadWorkflowAssignmentV3', 200>>[0] = {}) => {
  const url = new URL(
    `/v3/workflow_assignments/${params?.path.workflow_assignment_id}`,
    window.location.origin
  )
  url.search = queryString(params?.query)
  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
